var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemUser = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M15.138 13c2.791 0 5.062 2.243 5.062 5v2c0 .553-.453 1-1.012 1-.56 0-1.013-.447-1.013-1v-2c0-1.654-1.363-3-3.038-3H9.064c-1.675 0-3.038 1.346-3.038 3v2c0 .553-.453 1-1.013 1S4 20.553 4 20v-2c0-2.757 2.271-5 5.063-5ZM12.1 3c2.237 0 4.05 1.791 4.05 4s-1.813 4-4.05 4-4.05-1.791-4.05-4 1.813-4 4.05-4m0 2c-1.117 0-2.025.897-2.025 2s.908 2 2.025 2 2.025-.897 2.025-2-.908-2-2.025-2"
})));
export default SvgGemUser;